import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ProgramDto, ProgramFundingListItemDto, PlanData, RetailerLookupDto, StrategicBusinessInitiativeLookupDto, BrandLookupDto, BudgetYearLookupDto, SaveProgramCommand, ProgramId } from 'app/client-core/dtos/programs.model';
import { RetailerService } from 'app/client-core/services/retailer.service';
import { ProgramService } from 'app/client-core/services/program.service';
import { Observable, Subscription } from 'rxjs';
import { ValidationMessage } from 'app/validation';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { ApiResponse } from 'app/client-core/api-response-models';
import { Router } from '@angular/router';
import { BudgetYearTypeaheadComponent, StrategicBusinessInitiativesTypeaheadComponent, RetailersTypeaheadComponent } from '../typeahead';
import { BasicTypeaheadComponent } from '../typeahead/typeaheads/tactics/basic-typeahead.component';
import { CampaignThemeDto } from 'app/client-core/dtos/campaigns.model';
import { CampaignService } from 'app/client-core/services/campaign.service';
import { LayoutService } from '../layout/layout.service';
import { UserService } from 'app/client-core/services/user.service';
import { CierantTypeaheadComponent } from '../components/cierant-typeahead/cierant-typeahead.component';
import { TacticDto } from 'app/client-core/dtos/tactics.model';
import { ProgramDetailsTactic } from 'app/client-core/dtos/program-details';
import { TacticService } from 'app/client-core/services/tactic.service';
import { NotificationService } from '../utils/notification.service';
import { CierantSearchableTableComponent } from '../components/cierant-searchable-table/cierant-searchable-table.component';
import * as moment from 'moment';

@Component({
  selector: 'app-create-tactic-modal',
  templateUrl: './create-campaign-new-tactic.component.html',
  styleUrls: ['./create-campaign-new-tactic.component.scss']
})
export class CreateNewTacticComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tacticDto?: ProgramDetailsTactic;
  @Input() budgetYear: number;
  newtacticDto?: ProgramDetailsTactic = {} as ProgramDetailsTactic;
  @Input() programId: number;
  @Input() programStatusId: number;
  ready: boolean;
  submitted: boolean;
  tacticTypes = new Array<{ id, name, tacticFamily, selected: boolean }>();
  shopTypes = new Array<{ id, name }>();
  candelete: string;
  activeTab = "setup";
  @Input() uniPriSMUpgrade: boolean;
  validationMessages: ValidationMessage;
  submitting: boolean;
  selectedIndex = 0;
  @Input() programTacticId: number;
  @Input() componentId: number;
  loadingTactics = false;
  @ViewChild('app-cierant-searchable-table') searchableTable: CierantSearchableTableComponent;
  tacticTypeColumns = [
    {
      name: 'tacticFamily',
      displayName: 'Tactic Family'
    },
    {
      name: 'name',
      displayName: 'Name'
    }
  ]
  saving: boolean;
  programTacticComponentAddNewSubscription: any;
  updateTacticIdSubscription: Subscription;
  tacticId: number;

  constructor(
    private layoutService: LayoutService,
    private tacticService: TacticService,
    public userService: UserService,
    public notificationService: NotificationService,
    public programService: ProgramService,
    private ref: ChangeDetectorRef,
    private tactiService: TacticService
  ) {
  }
  ngOnDestroy(): void {
    if (this.updateTacticIdSubscription) {
      this.updateTacticIdSubscription.unsubscribe();
    }
  }

  clear() {
    this.saving = false;
    this.newtacticDto = {} as ProgramDetailsTactic;
  }

  ngOnInit() {
    // this.loadPage();
    this.programService.saveCampaingAndComponents.subscribe(data => {
      this.onSubmit(data.addNew);
    });

    this.programService.saveCampaingAndComponentsError.subscribe(() => {
      this.saving = false;
    });

    this.programTacticComponentAddNewSubscription = this.tactiService.programTacticComponentAddNew.subscribe(() => {
      setTimeout(() => {
        this.newtacticDto = {
          ...this.tacticDto,
          id: this.tacticDto.id || this.newtacticDto.id,
          description: this.newtacticDto.description,
          endDate: this.newtacticDto.endDate,
          startDate: this.newtacticDto.startDate,
        }
        this.layoutService.showCreateTactic.next({
          tacticDto: {
            ...this.newtacticDto,
            id: this.newtacticDto.id || this.tacticId
          }, 
          programId: this.programId,
          programStatusId: this.programStatusId,
          uniPriSMUpgrade: this.uniPriSMUpgrade,
          programTacticId: this.programTacticId,
          componentId: null,
          budgetYear: this.budgetYear
        });
      }, 200);
    });

    this.updateTacticIdSubscription = this.tactiService.updateProgramTacticId.subscribe(data => {
      this.tacticId = data;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ready = true;
    this.tacticTypes = [];

    if (changes.programId || changes.tacticDto) {
      setTimeout(() => {
        this.updateTacticOnComponent();
      }, 200);
      if (changes.componentId) {
        var selectedIndex = 0;
        if (this.tacticDto && this.tacticDto.programDetailsTacticComponent) {
          selectedIndex = this.tacticDto.programDetailsTacticComponent.findIndex(c => c.id == this.componentId);
          if (selectedIndex > -1) {
            this.selectedIndex = selectedIndex + 1;
          }
        }
        
      }
      
      this.setupTactic();

      if (this.tacticDto && this.tacticDto.id) {
        this.checkCanDelete();
      }
    }
  }

  loadTypes() {
    this.loadShopTypes();
    this.loadTacticTypes();
  }

  closeModal() {
    this.clear();
    this.layoutService.hideSideModal.next();
  }

  loadPage() {

  }

  loadTacticTypes() {
    this.loadingTactics = true;
    this.tacticService.getTacticTypes({ pageSize: 1000000000, programId: this.programId }).subscribe(response => {
      if (response.data && response.data.items) {
        console.log('this.tacticTypes', this.tacticTypes);
        this.loadingTactics = false;
        const id = this.tacticDto? this.tacticDto.id : this.tacticId;
        this.tacticTypes = this.tacticTypes.concat(response.data.items.filter(tc => this.tacticTypes.findIndex(ti => ti.id == tc.id) == -1).map(c => {
          return {
            ...c,
            selected: id ? this.tacticTypes.findIndex(t => t.id == id) > -1 : false
          }
        }));
      }
    });
  }

  loadShopTypes() {
    this.tacticService.getShopTypes({ 
      pageSize: 1000000000,
      programId: this.programId
    }).subscribe(response => {
      this.shopTypes = response.data.items;
    })
  }

  checkCanDelete() {
    this.tacticService.checkCanDeleteProgramTactic(this.tacticDto.id).subscribe(response => {
      this.candelete = response.data.canDelete;
    })
  }

  isProgramEndDateValid() {
    if (!this.newtacticDto || !this.newtacticDto.endDate) {
      return false;
    }
    return true;
  }

  isProgramStartDateValid() {
    if (!this.newtacticDto || !this.newtacticDto.endDate) {
      return false;
    }
    return true;
  }

  openComponent(componentID, index) {
    this.selectedIndex = index;
    this.tacticService.componentSelected.next({
      componentID,
      programTacticId: this.programTacticId
    })
  }

  canSubmit() {
    return this.isProgramStartDateValid() && this.isProgramEndDateValid() && this.isTacticTypeValid()
  }

  onSubmit(addNew?: boolean): void {
    this.submitted = false;
    this.saving = true;
    if (!this.canSubmit()) {
      this.submitted = true;
      this.saving = false;
      this.programService.saveCampaingAndComponentsError.next();
      this.validationMessages = new ValidationMessage(null, true, "There were some validation errors").isDanger();
      return;
    }

    this.newtacticDto.programId = this.programId;
    this.newtacticDto.tacticTypeId = this.tacticTypes.find(t => t.selected).id;
    this.tacticService.programTacticAdded.next({
      tactic: this.newtacticDto,
      addNew
    });
  }

  deleteProgramTactic() {
    this.notificationService.smartMessageBox({
      title: "",
      content: "Are you sure you would like to delete this program tactic? This program tactic will be completely removed from the system",
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
      if (ButtonPressed == "Yes") {
        this.tacticService.deleteProgramTactic(this.tacticDto.id).subscribe(response => {
          if (response.data) {
            this.validationMessages = new ValidationMessage(null, true, 'Program Tactic deleted').isSuccess();
            this.tacticService.programTacticDeletede.next();
            this.closeModal();
          } else {
            this.validationMessages = new ValidationMessage(null, true, 'Program Tactic can\'t deleted').isDanger();
            this.closeModal();
          }
        })
      }
    });
  }

  isTacticTypeValid() {
    return this.tacticTypes && this.tacticTypes.findIndex(t => t.selected) > -1;
  }

  getTaticTypeId() {
    if (this.tacticTypes && this.tacticTypes.findIndex(t => t.selected) > -1) {
      let id = this.tacticTypes.find(t => t.selected).id;
      return id;
    } else {
      if (this.tacticDto && this.tacticDto.tacticTypeId) {
        return this.tacticDto.tacticTypeId;
      }
    }
    return 0;
  }

  updateTacticOnComponent() {
    this.tacticService.updateComponentTactic.next({
      tactic: this.newtacticDto
    });

    if (this.newtacticDto.startDate) {
      if (this.newtacticDto.endDate && moment(this.newtacticDto.endDate).isBefore(moment(this.newtacticDto.startDate))) {
        this.newtacticDto.endDate = null;
      }
    }
  }

  tacticTypeIdChanged() {
    this.tacticService.tacticTypeIdChanged.next();
  }

  datesInsideBudgetYearRange() {
    if (!this.budgetYear) {
      return true;
    }

    if (this.newtacticDto.endDate && moment(this.newtacticDto.endDate).toDate().getFullYear() != this.budgetYear) {
      return false;
    }

    if (this.newtacticDto.startDate && moment(this.newtacticDto.startDate).toDate().getFullYear() != this.budgetYear) {
      return false;
    }

    return true;
  }

  getMinDate() {
    if (!this.newtacticDto) {
      return null;
    }
    return moment(this.newtacticDto.startDate).toDate();
  }
  
  setupTactic() {
    if (!this.tacticDto) {
      this.newtacticDto = new ProgramDetailsTactic();
    } else {
      if (this.tacticDto && this.tacticDto.tacticTypeId && !this.tacticTypes.find(t => t.id == this.tacticDto.tacticTypeId)) {
        this.tacticTypes.push({
          id: this.tacticDto.tacticTypeId,
          name: this.tacticDto.name,
          tacticFamily: '',
          selected: true
        });
      } else {
        // this.tacticTypes.find(t => t.id == null).selected = true;
      }
      this.newtacticDto = {
        ...this.tacticDto
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/create-new-tactic/create-campaign-new-tactic.component.ts